import { ChartSeriesData } from "../common";
import { Line } from "./types";

export const lineColor = (index: number, lineColors: string[]) => {
  const newIndex = (index + 1) % lineColors.length;
  return lineColors[newIndex];
};

export const getChartRangeValues = (
  data: ChartSeriesData[],
  isValuationChart: boolean
) => {
  const allValue = isValuationChart
    ? data
        .map((x) => x.data)
        .flat()
        .map((x) => x[1])
    : [];

  const max = Math.max(...allValue);
  const min = Math.min(...allValue);
  return {
    min: isValuationChart ? min : undefined,
    max: isValuationChart ? max : undefined,
  };
};

export const getSeriesPoint = (
  clickedPoint: Highcharts.Point,
  searchSeriesName: string
) => {
  const compareSeries = clickedPoint.series.chart.series.find(
    (series) => series.name === searchSeriesName
  );
  return compareSeries?.data?.find((point) => point.x === clickedPoint.x);
};

export const getAnnotationShapes = (lines: Line[], chartColors: string[]) => {
  return lines.map((line, index) => ({
    shapes: [
      {
        type: "path",
        points: [
          { x: line.x1, y: line.y1, xAxis: 0, yAxis: 0 },
          { x: line.x2, y: line.y2, xAxis: 0, yAxis: 0 },
        ],
        strokeWidth: 2,
        stroke: lineColor(index, chartColors),
        dashStyle: "Solid",
      },
    ],
  }));
};
